import request from '@/utils/request'


// 查询学员案例列表
export function listStudent(query) {
  return request({
    url: '/shop/student/list',
    method: 'get',
    params: query
  })
}

// 查询学员案例分页
export function pageStudent(query) {
  return request({
    url: '/shop/student/page',
    method: 'get',
    params: query
  })
}

// 查询学员案例详细
export function getStudent(data) {
  return request({
    url: '/shop/student/detail',
    method: 'get',
    params: data
  })
}

// 新增学员案例
export function addStudent(data) {
  return request({
    url: '/shop/student/add',
    method: 'post',
    data: data
  })
}

// 修改学员案例
export function updateStudent(data) {
  return request({
    url: '/shop/student/edit',
    method: 'post',
    data: data
  })
}

// 删除学员案例
export function delStudent(data) {
  return request({
    url: '/shop/student/delete',
    method: 'post',
    data: data
  })
}
  // 获取课程名称
  export function shopName() {
    return request({
      url: '/shop/student/shopName',
      method: 'get',
    })


  }

// 获取课程名称
export function coachName(data) {
  return request({
    url: '/shop/student/coachName',
    method: 'get',
    params: data
  })


}